var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main-content main-crm-content" }, [
    _vm._m(0),
    _c(
      "div",
      { staticClass: "container new-list" },
      _vm._l(_vm.newList, function(item, key) {
        return _c("div", { key: key, staticClass: "item" }, [
          _c("p", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _c("img", { attrs: { src: item.icon, alt: "" } }),
          _c("p", { staticClass: "con" }, [_vm._v(_vm._s(item.value))])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container content-title" }, [
      _c("img", {
        staticClass: "img-box",
        attrs: { src: require("static/images/trait/crm.png"), alt: "oa" }
      }),
      _c("h3", { staticClass: "services-title1" }, [_vm._v("客户管理系统")]),
      _c("p", { staticClass: "container-sub-title sub-title" }, [
        _vm._v(
          "CRM软件集中并分类管理客户，客户售前-售中-售后完整记录,企业重要往来信息，一键关联，快速进行商机挖掘-评估-分配"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-259de132", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-259de132","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/crm/Content.vue
// module id = o8Wr
// module chunks = 12 13